import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';

const ProblemStatement: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-dark to-dark text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex flex-col items-center text-center mb-16"
          >
            <Clock className="w-12 h-12 text-primary mb-6 opacity-70" />
            <h2 className="font-serif text-3xl md:text-4xl font-semibold mb-8 leading-tight">
              The average person loses <span className="text-primary">2.1 hours daily</span> to digital distraction
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mt-12">
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/5 transform transition-all duration-300 hover:translate-y-[-5px]"
              >
                <div className="text-primary text-4xl font-bold mb-1">
                  142
                </div>
                <p className="text-white/60 text-sm">
                  Times the average person checks their phone daily
                </p>
              </motion.div>
              
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/5 transform transition-all duration-300 hover:translate-y-[-5px]"
              >
                <div className="text-primary text-4xl font-bold mb-1">
                  4h 12m
                </div>
                <p className="text-white/60 text-sm">
                  Average daily screen time in 2024
                </p>
              </motion.div>
              
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.6 }}
                className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/5 transform transition-all duration-300 hover:translate-y-[-5px]"
              >
                <div className="text-primary text-4xl font-bold mb-1">
                  76%
                </div>
                <p className="text-white/60 text-sm">
                  Of people report feeling overwhelmed by notifications
                </p>
              </motion.div>
            </div>
            
            <motion.div 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.8 }}
              className="mt-16"
            >
              <div className="w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent"></div>
              <p className="mt-8 font-serif text-xl text-white/80 italic">
                "What we attend to creates our lives..."
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProblemStatement;